export const SET_CONVERSATION = 'CHAT:SET_CONVERSATION';
export const SET_CONVERSATION_PREVIEW = 'CHAT:SET_CONVERSATION_PREVIEW';
export const ADD_TO_CONVERSATION = 'CHAT:ADD_TOCONVERSATION';
export const UPDATE_PREVIEW = 'CHAT:UPDATE_PREVIEW';
export const READ_PREVIEW = 'CHAT:READ_PREVIEW';
export const READ_MESSAGE = 'CHAT:READ_MESSAGE';